import React, { useMemo } from "react";
import useLocalStorage from "../../hooks/useLocalStorage";
import { MenuContext } from "./context";

export const MenuState = ({ children }) => {
  const [isHideMenu, setIsHideMenu] = useLocalStorage("isHideMenu", false);

  const value = useMemo(
    () => ({
      isHideMenu,
      setIsHideMenu,
    }),
    // eslint-disable-next-line
    [isHideMenu]
  );

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
